<template>
  <AppAside>
    <p>
      <span class="app-office">Commercial Trailers over 26,000 lbs. </span> are registered in the Business and Commercial Unit.
      Email <a href="mailto:DMV.BusinessCommercial@dmv.ri.gov">DMV.BusinessCommercial@dmv.ri.gov</a> for an appointment.
    </p>
    <p>
      <span class="app-office">Fleet, Municipalities, and School Bus Certificate</span> reservations are scheduled directly through the DMV
      Business and Commercial office. For additional information please call 401-462-5772 or email <a href="mailto:DMV.SchoolBus@dmv.ri.gov">DMV.SchoolBus@dmv.ri.gov</a>.
    </p>
    <p>
      <span class="app-office">The Adjudication office</span> handles driving records, suspensions,
      reinstatements, and insurance verification.
    </p>
    <p>
      <span class="app-office">The Cashier's office</span> handles issues such as bounced checks.
    </p>
    <p>
      <span class="app-office">The CDL office</span> handles all commercial driver transactions such as
      testing, commercial learner permits, commercial driver licenses, medical certificates, and chauffeur
      licenses.
    </p>
    <p>
      <span class="app-office">The License and Registration office</span> handles transactions for State ID cards,
      learner permits, permit tests, driver licenses, vehicle registrations, and new vehicle titles. If you are renewing or
      requesting a duplicate for an existing DPC license, permit, or ID, please select a “License/ ID / Registration / Permit”
      reservation instead.
    </p>
    <p>
      <span class="app-office">The Research office</span> handles salvage titles, duplicate titles, security
      additions, lien removals, and printed license and registration inquiries.
    </p>
  </AppAside>
</template>


<script setup>
import AppAside from './AppAside.vue';

defineOptions({
  name: 'AsideForType',
});
</script>
